export const UPDATE_USER_STEP = 'UPDATE_USER_STEP';
export const SET_NEIGHBOURHOOD = 'SET_NEIGHBOURHOOD';
export const SET_NEIGHBOURHOODS = 'SET_NEIGHBOURHOODS';
export const SET_RECOMMENDED_NEIGHBOURHOODS = 'SET_RECOMMENDED_NEIGHBOURHOODS'
export const RESET_RECOMMENDED_NEIGHBOURHOODS = 'RESET_RECOMMENDED_NEIGHBOURHOODS'
export const SET_TRAVEL_MODE = 'SET_TRAVEL_MODE';
export const SET_NEIGHBOURHOOD_HOVER_NAME = 'SET_NEIGHBOURHOOD_HOVER_NAME';
export const SET_SEARCH_BOX_RESULT = 'SET_SEARCH_BOX_RESULT';
export const SET_COMMUTE = 'SET_COMMUTE';
export const TOGGLE_MAP = 'TOGGLE_MAP';
export const SET_COLOURS = 'SET_COLOURS';

export function updateUserStep(step) {
  return {type: UPDATE_USER_STEP, payload: step};
}

export function setNeighbourhood(id) {
  return {type: SET_NEIGHBOURHOOD, payload: id};
}

export function setColours(colours) {
  return {type: SET_COLOURS, payload: colours};
}

export function setCommute(commute) {
  return {type: SET_COMMUTE, payload: commute};
}

export function toggleMap(display) {
  return {type: TOGGLE_MAP, payload: display};
}

export function setRecommendedNeighbourhoods(neighbourhoods) {
  return {type: SET_RECOMMENDED_NEIGHBOURHOODS, payload: neighbourhoods}
}

export function resetRecommendedNeighbourhoods() {
  return {type: RESET_RECOMMENDED_NEIGHBOURHOODS}
}

export function setTravelMode(mode) {
  return {type: SET_TRAVEL_MODE, payload: mode}
}

export function setNeighbourhoodHoverName(name) {
  return {type: SET_NEIGHBOURHOOD_HOVER_NAME, payload: name}
}

export function setSearchBoxResult(location) {
  return {type: SET_SEARCH_BOX_RESULT, payload: location}
}



// WEBPACK FOOTER //
// ./src/actions/Map/navActions.js